import { Component, OnInit, ViewEncapsulation, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialogRef, MatDialog, MatAutocompleteTrigger, MatSnackBar } from '@angular/material';
import { fuseAnimations } from '../../../../../../../../../../core/animations';
import * as _ from "lodash";
import { FuseCopierService } from '../../../../../../../../../../core/services/copier.service';

// common values and models
import { displayValues, toastMsg } from '../../../../../../../utils';
import { SolutionDescriptionInitialDM, FetchAllSolutionDescription, SolutionDescriptionNodes, CreateSolutionDescription } from '../../../../../../../models';
//Common components
import { ToastComponent } from '../../../../../../../common/toast.component';
//Local component
import { EditSolutionComponent } from '../edit-solution-description/edit-solution.component';
//Service file
import { SideNavService } from '../../../../sidenav.service';
import { Subscription, Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { FuseConfirmDialogComponent } from '../../../../../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { environment } from '../../../../../../../../../../../environments/environment';
import { AuditHistoryService } from '../../../../../../../../../../core/services/audit-history.service';

@Component({
  selector: 'spekwo-search-solution-description',
  templateUrl: './search-solution-description.component.html',
  styleUrls: ['./search-solution-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})

export class SearchSolutionDescriptionComponent implements OnInit {

  @Input() searchType: string;
  @Output() selectedSolution = new EventEmitter<SolutionDescriptionInitialDM>();
  @Input() viewType: string;
  displayValues = displayValues;
  solutionFields: SolutionDescriptionInitialDM = Object.assign({}, initialValues);
  newParams;
  filteredSolutions: SolutionDescriptionNodes[] = [];
  filteredSolutionsDataSource: MatTableDataSource<SolutionDescriptionNodes>;
  displayedColumns = ['primaryCategory', 'subCategory', 'solution', 'totalCost', 'drag', 'buttons'];
  tmCostOption: string[] = ['tm', 'Flat', 'foot'];
  defaultSubcatory: any;

  selectedId: number;
  @ViewChild(MatPaginator) searchSolutionPaginator: MatPaginator;
  @ViewChild(MatSort) searchSolutionSort: MatSort;
  @ViewChild('keyprimeInput', { read: MatAutocompleteTrigger }) keyprimeInputautocomplete: MatAutocompleteTrigger;
  @ViewChild('Key1Input', { read: MatAutocompleteTrigger }) Key1Inputautocomplete: MatAutocompleteTrigger;
  @ViewChild('Key2Input', { read: MatAutocompleteTrigger }) Key2Inputautocomplete: MatAutocompleteTrigger;
  @ViewChild('Key3Input', { read: MatAutocompleteTrigger }) Key3Inputautocomplete: MatAutocompleteTrigger;
  @ViewChild('Key4Input', { read: MatAutocompleteTrigger }) Key4Inputautocomplete: MatAutocompleteTrigger;

  private _subscriptions: Subscription[] = [];
  isSolutionsUpdated: Observable<boolean>;

  dialogRef: any;
  isAllDataFetched: boolean = false;
  tableLoader: boolean = false;
  toastMsg = toastMsg;
  enableSearch: boolean = false;
  lastEnteredWord: string;
  suggesstionsWordType: string;
  tableType: string = 'create';
  selectedCostOption: string = '';
  primaryCategory: string;
  categoryId: number;

  searchSuggestions: SuggesstionsList = Object.assign({}, defaultSetData);
  searchTerm$ = new Subject<string>();

  enableSave: boolean = false;
  primaryCategories: any;
  primaryCategoriesList: any;
  subCategories: any;
  searchResultRemove: boolean = false;

  dragIndexForReports: number;
  selectedIdInDrag: string = '';
  searchSolutionsForDrag: SolutionDescriptionNodes[] = [];
  primaryList: any;
  subcategoryList: any;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

  public userId: any;
  public roleId: any;
  isHighLevelPermission: boolean;

  constructor(
    private _fuseCopierService: FuseCopierService,
    private _sideNavService: SideNavService,
    public dialog: MatDialog,
    private _matSnackBar: MatSnackBar,
    private _toastComponent: ToastComponent,
    public auditHistoryService: AuditHistoryService,

  ) {

    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem('roleId');
    this.isHighLevelPermission = environment.ownerRoleId === this.roleId || environment.executiveRoleId === this.roleId;

    this.isSolutionsUpdated = this._sideNavService.onSolutionInfo.asObservable();
    this._subscriptions.push(this.search(this.searchTerm$)
      .subscribe(results => {
        // this.isSDLoad = false;
        // this.matchedResult = results;
      }));
  }


  ngOnInit() {
    this.dragIndexForReports = 0;
    this.primaryCategoryFliter("");
    //Subscription to watch any changes happen in table data(add)
    this._subscriptions.push(
      this.isSolutionsUpdated.subscribe((event) => {
        if (event) {
          if (this.enableSearch) {
            this.onSubmitFile();
          }

        }
      })
    );
    this._sideNavService.getAllCategories().then((response: any) => {
      this.primaryList = response.data.allWccategories.nodes;
    })
  }

  primaryCategoryFliter(event) { // browse and check restriction
    let searchCategory = event;
    //SearchCategories
    if (typeof (searchCategory) !== 'number') { // check again incase 1.2 1.1 as store primary cate
      this._sideNavService.searchPrimaryCategories(searchCategory).then(
        (response: any) => {
          if (response && response.data && response.data.allWccategories && response.data.allWccategories.nodes && response.data.allWccategories.nodes.length > 0) {
            this.primaryCategories = response.data.allWccategories.nodes;
            this.primaryCategoriesList = response.data.allWccategories.nodes;
          }
        }
      ).catch((err) => {
        console.log(err);
      });
    }

  }

  //copy source
  copySource(text: string): void {
    if (this._fuseCopierService.copyText(text)) {
      this.showToastMessage(this.displayValues.copiedSuccess, this.displayValues.success);
    }
    else {
      this.showToastMessage(this.displayValues.copiedFailed, this.displayValues.failed);
    }
  }

  showToastMessage(message: string, toastType: string) {
    this._matSnackBar.open(message, 'OK', {
      verticalPosition: 'top',
      duration: 2000,
      panelClass: [toastType],
    });
  }

  //Bec, initially load paginator only
  ngAfterViewInit() {
    if (this.filteredSolutionsDataSource) {
      this.filteredSolutionsDataSource.paginator = this.searchSolutionPaginator;
      this.filteredSolutionsDataSource.sort = this.searchSolutionSort;
    }
  }


  //Checking condition to enable search button
  onSaveCheck(event) {
    if ((this.solutionFields.keyPrimCategory.length && this.solutionFields.keyPrimCategory.length > 0)
      || (this.solutionFields.subcategory.length && this.solutionFields.subcategory.length > 0)
      || (this.solutionFields.key1.length && this.solutionFields.key1.length > 0)
      || (this.solutionFields.key2.length && this.solutionFields.key2.length > 0)
      || (this.solutionFields.key3.length && this.solutionFields.key3.length > 0)
      || (this.solutionFields.key4.length && this.solutionFields.key4.length > 0)
    ) {
      this.enableSearch = true;
    }
    else {
      this.enableSearch = false;
      this.isAllDataFetched = false;
    }
  }

  //Keyup funciton to getting searchList dynamically
  searchInterest(word: string) {
    // this.matchedResult = [];
    var value = word;
    if (value) {
      this.searchTerm$.next(word);
    }
  }

  //Getting macthed keywords list
  search(terms: Observable<string>) {  // check function
    return terms.debounceTime(300)
      // .distinctUntilChanged()
      .switchMap(term => {
        // this.isSDLoad = true;
        return this.checkIsTheKeyPresent(term)
      }
      );
  }

  checkIsTheKeyPresent(searchWord?: string) {
    return this._sideNavService.searchIsTheKeywordPresent(searchWord).then((res) => {
      var searchResult = res['data']['allSolutionDescriptions']['nodes'];
      if (searchResult.length == 0) {
        this.showSuggesstions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }


  showSuggesstions() {
    this.suggesstionsWordType = (this.lastEnteredWord == 'keyPrimCategory') ? 'CATEGORY' : 'KEY';
    this._sideNavService.gettingSuggesstionsWords(this.solutionFields[this.lastEnteredWord], this.suggesstionsWordType).then((res) => {
      this.searchSuggestions[this.lastEnteredWord] = Object.assign([], res);
      this.searchSuggestions[this.lastEnteredWord] = _.uniq(this.searchSuggestions[this.lastEnteredWord]);
      switch (this.lastEnteredWord) {
        case 'keyPrimCategory': this.keyprimeInputautocomplete.openPanel();
          break;
        case 'key1': this.Key1Inputautocomplete.openPanel();
          break;
        case 'key2': this.Key2Inputautocomplete.openPanel();
          break;
        case 'key3': this.Key3Inputautocomplete.openPanel();
          break;
        case 'key4': this.Key4Inputautocomplete.openPanel();
          break;
        default: this.keyprimeInputautocomplete.openPanel();
          break;
      }
    });
  }


  //On Button submit and calling service file
  onSubmitFile() {
    this.isAllDataFetched = false;
    this.tableLoader = true;
    this.filteredSolutions = [];
    this.solutionFields.keyword = [];
    //Pushing if the keywords fields are entered
    if (this.solutionFields.key1.length > 0) {
      this.solutionFields.keyword.push(this.solutionFields.key1);
    }
    if (this.solutionFields.key2.length > 0) {
      this.solutionFields.keyword.push(this.solutionFields.key2);
    }
    if (this.solutionFields.key3.length > 0) {
      this.solutionFields.keyword.push(this.solutionFields.key3);
    }
    if (this.solutionFields.key4.length > 0) {
      this.solutionFields.keyword.push(this.solutionFields.key4);
    }

    //Fetching solutions with filtered options
    this._sideNavService.fetchingSolutionDescriptionByFilter(this.solutionFields).then((res: SolutionDescriptionNodes[]) => {
      if (res.length > 0) {
        this.filteredSolutions = res;
        this.searchSolutionsForDrag = this.filteredSolutions.slice(0);
        this.assignDataSource();
        this.searchSuggestions = Object.assign({}, defaultSetData);
      } else {
        this.tableLoader = false;
        this.isAllDataFetched = true;
        this.searchSuggestions = Object.assign({}, defaultSetData);
      }
    }).catch((err) => {
      this.tableLoader = true;
      this.isAllDataFetched = true;
      this._toastComponent.showToast(this.toastMsg.uploadCompanyLogoFailed);
      console.log("CreateSolutionDescription", err);
    });

    this.searchResultRemove = false;
  }

  //Save button enable conditions
  onSaveCheckForAddtoDb(event) {
    if (this.solutionFields.costOption.length == 0 || this.solutionFields.subcategory.length == 0 || this.solutionFields.keyPrimCategory.length == 0 ||
      this.solutionFields.keyPhrase.length == 0 || this.solutionFields.key1.length == 0
      || this.solutionFields.key2.length == 0 || this.solutionFields.solution.length == 0
      || !this.solutionFields.totalCost) {
      this.enableSave = false;
    }
    else {
      this.enableSave = true;
    }
  }

  // Cost selection dropdown
  costSelection(selected: string) {
    //Resetting cost values while changing cost option
    if (this.solutionFields.costOption.length > 0) {
      this._toastComponent.showToast(this.toastMsg.changingCostOptionWarning);
      this.solutionFields.cpf = null;
      this.solutionFields.cpi = null;
      this.solutionFields.hourRate = null;
      this.solutionFields.laborHour = null;
      this.solutionFields.labourCost = null;
      this.solutionFields.tf = null;
      this.solutionFields.totalCost = null;
      this.tableType = 'create';
    }
    this.solutionFields.costOption = selected;
    this.onSaveCheckForAddtoDb('');
    this.selectedCostOption = selected;
  }
  //Assigning cost values
  calculatedCostValues(event: any) {
    _.map(event, (value, key) => {
      this.solutionFields[key] = value;
    });
    this.onSaveCheckForAddtoDb('');
  }

  //To close the cost table
  closeEstimateTable(event) {
    if (event) {
      this.selectedCostOption = '';
    }
  }

  viewEstimateTable() {
    this.tableType = 'edit';
    this.selectedCostOption = this.solutionFields.costOption;
  }

  onSubmitFileForAddToDb(submitedValues?: SolutionDescriptionInitialDM) {
    this.enableSave = false;
    // this.solutionFields = submitedValues;
    this.solutionFields.keyword = [];
    //Pushing keywords fields to keyword array
    this.solutionFields.keyword.push(this.solutionFields.key1);
    this.solutionFields.keyword.push(this.solutionFields.key2);
    this.solutionFields.keyword.push(this.solutionFields.key3);
    this.solutionFields.keyword.push(this.solutionFields.key4);

    console.log("created form", this.solutionFields.keyword);
    // this.isSolutionUpload = true;
    // Store in db
    this._sideNavService.CreateSolutionDescriptionOnDb(this.solutionFields)
      .then(async (createRes: CreateSolutionDescription) => {
        // this.isSolutionUpload = false;
        this._toastComponent.showToast(this.toastMsg.uploadSolutionDescriptionSuccess);
      }).catch((err) => {
        // this.isSolutionUpload = false;
        this.enableSave = true;
        this._toastComponent.showToast(this.toastMsg.uploadCompanyLogoFailed);
        console.log("CreateSolutionDescription", err);
      });
  }

  //Assigning data source
  assignDataSource(filteredSolutions?: any) {
    this.filteredSolutionsDataSource = new MatTableDataSource(this.filteredSolutions);
    this.filteredSolutionsDataSource.paginator = this.searchSolutionPaginator;
    this.filteredSolutionsDataSource.sort = this.searchSolutionSort;
    this.isAllDataFetched = true;
    this.tableLoader = false;
  }


  /** Based on row select- Highlight row */
  onSelect(selected) {
    this.selectedId = selected.id;
  }

  //Edit functionality
  editContact(solution: any) {
    this.dialogRef = this.dialog.open(EditSolutionComponent, {
      width: '100%',
      height: 'auto',
      panelClass: 'solution-form-dialogs',
      data: {
        solution: solution,
      }
    });

    //Getting response from edit component
    this.dialogRef.afterClosed()
      .subscribe(response => {

        if (!response) {
          return;
        }
        const updatedSolution: SolutionDescriptionNodes = response[0]
        const status: string = response[1];


        if (status == 'success') {

          //Finding index of selected row
          var index = this.filteredSolutions.findIndex(function (solutiondesc) {
            return solutiondesc.id == solution.id
          });
          //Update array with updated row values
          this.filteredSolutions[index] = Object.assign({}, updatedSolution);
          //Re assigning table data
          this.assignDataSource();

        }

        //store primary category in DB

        //flag handling
        let check = _.filter(this.primaryList, data => {
          if (updatedSolution.keyPrimCategory.toUpperCase().trim() == data.category.trim()) {
            return data.category;
          }
        }
        );

        if (updatedSolution.keyPrimCategory) {
          if (check && check.length > 0) {
            console.log("primary category already present");
          }
          else {
            console.log("primary category not present");
            this._sideNavService.createPrimaryCategory(updatedSolution.keyPrimCategory).then((response: any) => {
              updatedSolution.categoryid = response.data.createWccategory.wccategoryEdge.node.categoryid;
              this.createSubCategory(updatedSolution.categoryid, updatedSolution.subcategory);
            }).catch((err) => {
              console.log(err);
            })
          }
          if (check && check.length && check[0].categoryid && updatedSolution.subcategory) {
            this.createSubCategory(check[0].categoryid, updatedSolution.subcategory);
          }
        }
      });
  }

  createSubCategory(categoryId, subCategoryValue) {
    //get sub category from here for check already present or not
    if (categoryId) {
      this._sideNavService.getAllSubCategories(categoryId).then(
        (response: any) => {
          if (response && response.data && response.data.allWcsubcategories && response.data.allWcsubcategories.nodes && response.data.allWcsubcategories.nodes.length > 0) {
            this.subcategoryList = response.data.allWcsubcategories.nodes;
            let checkSub = _.filter(this.subcategoryList, data => {
              if (subCategoryValue.toUpperCase().trim() === data.subcategory.toUpperCase().trim()) {
                return data.subcategory;
              }
            }
            );
            if (checkSub && checkSub.length > 0) {
              console.log("sub category already present");
            }
            else {
              console.log("sub category not present");
              if (categoryId) {
                this._sideNavService.createSubCategory(categoryId, subCategoryValue).then((response: any) => {
                }).catch((err) => {
                  console.log(err);
                })
              }
            }
          }
          else {
            console.log("No sub category so create first sub category");
            if (categoryId) {
              this._sideNavService.createSubCategory(categoryId, subCategoryValue).then((response: any) => {
              }).catch((err) => {
                console.log(err);
              })
            }
          }
        }
      ).catch((err) => {
        console.log(err);
      });
    }
  }
  selectSolution(solution: any) {
    this.selectedSolution.emit(solution);
  }

  selectPrimaryCategory(selectPrimaryCategoryName) {
    this.solutionFields.subcategory = '';
    if (selectPrimaryCategoryName.option.value) {
      let check = _.filter(this.primaryCategories, event => // check
        event.categoryid === selectPrimaryCategoryName.option.value);
      if (check && check.length > 0) {
        let categoryId = check[0].categoryid;
        this.solutionFields.keyPrimCategory = check[0].category;
        if (categoryId) {
          this._sideNavService.getAllSubCategories(categoryId).then(
            (response: any) => {
              if (response && response.data && response.data.allWcsubcategories && response.data.allWcsubcategories.nodes && response.data.allWcsubcategories.nodes.length > 0) {
                this.subCategories = response.data.allWcsubcategories.nodes;
              }
              else {
                this.subCategories = [];
              }
              //check sub category length
              if (this.subCategories.length > 0) {
                // this.defaultSubcatory=this.subCategories[0].subcategory;
                // this.solutionFields.subcategory= this.defaultSubcatory; // add before
              }
              else {
                console.log("No sub category ");
              }
            }
          ).catch((err) => {
            console.log(err);
          });
        }
      }// else block
    }
    this.primaryCategories = [];
  }

  selectSubCategory(selectSubCategoryName) {
    let selectSubCategory = selectSubCategoryName.value;
    this.solutionFields.subcategory = selectSubCategory;
  }

  resetVaules(solution) {
    this.solutionFields.keyPrimCategory = '';
    this.solutionFields.subcategory = '';
    this.solutionFields.key1 = '';
    this.solutionFields.key2 = '';
    this.solutionFields.key3 = '';
    this.solutionFields.key4 = '';
    this.defaultSubcatory = '';
    this.searchResultRemove = true;
    this.primaryCategoryFliter('');
    this.subCategories = [];
  }
  drag(event, id) {
    this.selectedIdInDrag = id;
  }
  transferDataSuccess(dragIndexForReports, event) {
    this.filteredSolutionsDataSource = new MatTableDataSource(this.filteredSolutions);
    this.saveDragSolution(this.filteredSolutions);
    this.selectedIdInDrag = '';
  }
  saveDragSolution(filteredSolutions) {
    var temp1 = [];
    filteredSolutions.forEach((data, key) => {
      var temp = {
        id: this.searchSolutionsForDrag[key].id,
        keyPrimCategory: data.keyPrimCategory,
        subcategory: data.subcategory,
        cost: data.cost,
        key1: data.key1,
        key2: data.key2,
        key3: data.key3,
        key4: data.key4,
        keyword: data.keyword,
        solution: data.solution,
        costOption: data.costOption,
        totalCost: data.totalCost,
        cpf: data.cpf ? Number.parseFloat(data.cpf) : null,
        cpi: data.cpi ? Number.parseFloat(data.cpi) : null,
        hourRate: data.hourRate ? Number.parseFloat(data.hourRate) : null,
        laborHour: data.laborHour ? Number.parseInt(data.laborHour) : null,
        labourCost: data.labourCost ? Number.parseFloat(data.labourCost) : null,
        materialCost: data.materialCost ? Number.parseFloat(data.materialCost) : null,
        ni: data.ni ? Number.parseInt(data.ni) : null,
        tf: data.tf ? Number.parseInt(data.tf) : null,
        irl: data.irl,
        keyPhrase: data.keyPhrase,
      }
      temp1.push(temp);
      if (key + 1 == this.searchSolutionsForDrag.length) {
        filteredSolutions = temp1;
        this.updateDragSolution(filteredSolutions);
      }
    });
  }
  updateDragSolution(filteredSolutions: any) {
    filteredSolutions.forEach((solution, key) => {
      this._sideNavService.updateSolutionDescriptionByIdOnDb(solution).then((response: any) => {
        if (key + 1 == filteredSolutions.length) {
          this._toastComponent.showToast(this.toastMsg.afterReview);
        }
      }).catch((err) => {
        console.log(err);
        this._toastComponent.showToast(this.toastMsg.failedReview);
      })
    });
  }

  //Delete functionalityyp
  deleteContact(solutionId: number, solution: SolutionDescriptionNodes) {
    this.newParams = solution;
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.displayValues.manageRef.deleteConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.displayValues.manageRef.deleteHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.displayValues.manageRef.deleteOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.displayValues.manageRef.deleteCancel;

    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.tableLoader = true;
        this._sideNavService.
          deleteSolutionDescriptionByIdOnDb(solutionId).then((res) => {
            if (res) {
              this.auditHistoryFunCall(displayValues.success)
              this._toastComponent.showToast(this.toastMsg.deleteScheSuccess);
              this.filteredSolutions = _.pull(this.filteredSolutions, solution);
              this.assignDataSource(this.filteredSolutions);
            }
          }, () => {
            this.auditHistoryFunCall(displayValues.failed)
            this._toastComponent.showToast(this.toastMsg.deleteScheFailed);
          }).catch((err) => {
            console.log(err);
          });
      } 
      this.confirmDialogRef = null;
    });

  }
  auditHistoryFunCall(status) {
    let newParams = {
      "solution": this.newParams && this.newParams.solution ? this.newParams.solution : null,
      "keyPrimCategory": this.newParams && this.newParams.keyPrimCategory ? this.newParams.keyPrimCategory : null,
      "subcategory": this.newParams && this.newParams.subcategory ? this.newParams.subcategory : null,
      "key1": this.newParams && this.newParams.key1 ? this.newParams.key1 : null,
      "key2": this.newParams && this.newParams.key2 ? this.newParams.key2 : null,
      "key3": this.newParams && this.newParams.key3 ? this.newParams.key3 : null,
      "key4": this.newParams && this.newParams.key4 ? this.newParams.key4 : null,
      "costOption": this.newParams && this.newParams.costOption ? this.newParams.costOption : null,
      "totalCost": this.newParams && this.newParams.totalCost ? this.newParams.totalCost : null,
    };

    let auditLogPayload = {
      roleId: window.localStorage.getItem('roleId'),
      userId: window.localStorage.getItem('userUID'),
      orderId: null,
      newData: newParams,
      oldData: null,
      auditType: "delete_se_into_db",
      logsDesc: "Solution was deleted to the database ",
      platform: "Executive Dashboard",
      status: status,
      createdAt: "now()"

    };
    this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
  }

}

//Default Values
const initialValues: SolutionDescriptionInitialDM = {
  keyword: [],
  solution: '',
  cost: null,
  keyPrimCategory: '',
  subcategory: '',
  key1: '',
  keyPhrase: '',
  key2: '',
  key3: '',
  key4: '',
  irl: '',
  costOption: '',
  labourCost: null,
  hourRate: null,
  laborHour: null,
  materialCost: null,
  ni: null,
  tf: null,
  cpi: null,
  cpf: null,
}

export interface SuggesstionsList {
  keyPrimCategory?: string[];
  key1?: string[];
  key2?: string[];
  key3?: string[];
  key4?: string[];
}

const defaultSetData: SuggesstionsList = {
  keyPrimCategory: [],
  key1: [],
  key2: [],
  key3: [],
  key4: []
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/search-solution-description/search-solution-description.component.ts